export const COUNTRY_CODES = [
  { code: '+91',   iso: 'IN', country: 'India' },
  { code: '+93',   iso: 'AF', country: 'Afghanistan' },
  { code: '+355',  iso: 'AL', country: 'Albania' },
  { code: '+213',  iso: 'DZ', country: 'Algeria' },
  { code: '+376',  iso: 'AD', country: 'Andorra' },
  { code: '+244',  iso: 'AO', country: 'Angola' },
  { code: '+1268', iso: 'AG', country: 'Antigua and Barbuda' },
  { code: '+54',   iso: 'AR', country: 'Argentina' },
  { code: '+374',  iso: 'AM', country: 'Armenia' },
  { code: '+61',   iso: 'AU', country: 'Australia' },
  { code: '+43',   iso: 'AT', country: 'Austria' },
  { code: '+994',  iso: 'AZ', country: 'Azerbaijan' },
  { code: '+1242', iso: 'BS', country: 'Bahamas' },
  { code: '+973',  iso: 'BH', country: 'Bahrain' },
  { code: '+880',  iso: 'BD', country: 'Bangladesh' },
  { code: '+1246', iso: 'BB', country: 'Barbados' },
  { code: '+375',  iso: 'BY', country: 'Belarus' },
  { code: '+32',   iso: 'BE', country: 'Belgium' },
  { code: '+501',  iso: 'BZ', country: 'Belize' },
  { code: '+229',  iso: 'BJ', country: 'Benin' },
  { code: '+975',  iso: 'BT', country: 'Bhutan' },
  { code: '+591',  iso: 'BO', country: 'Bolivia' },
  { code: '+387',  iso: 'BA', country: 'Bosnia and Herzegovina' },
  { code: '+267',  iso: 'BW', country: 'Botswana' },
  { code: '+55',   iso: 'BR', country: 'Brazil' },
  { code: '+673',  iso: 'BN', country: 'Brunei' },
  { code: '+359',  iso: 'BG', country: 'Bulgaria' },
  { code: '+226',  iso: 'BF', country: 'Burkina Faso' },
  { code: '+257',  iso: 'BI', country: 'Burundi' },
  { code: '+238',  iso: 'CV', country: 'Cabo Verde' },
  { code: '+855',  iso: 'KH', country: 'Cambodia' },
  { code: '+237',  iso: 'CM', country: 'Cameroon' },
  { code: '+1',    iso: 'CA', country: 'Canada' },
  { code: '+236',  iso: 'CF', country: 'Central African Republic' },
  { code: '+235',  iso: 'TD', country: 'Chad' },
  { code: '+56',   iso: 'CL', country: 'Chile' },
  { code: '+86',   iso: 'CN', country: 'China' },
  { code: '+57',   iso: 'CO', country: 'Colombia' },
  { code: '+269',  iso: 'KM', country: 'Comoros' },
  { code: '+242',  iso: 'CG', country: 'Congo' },
  { code: '+243',  iso: 'CD', country: 'Congo (DRC)' },
  { code: '+506',  iso: 'CR', country: 'Costa Rica' },
  { code: '+385',  iso: 'HR', country: 'Croatia' },
  { code: '+53',   iso: 'CU', country: 'Cuba' },
  { code: '+357',  iso: 'CY', country: 'Cyprus' },
  { code: '+420',  iso: 'CZ', country: 'Czech Republic' },
  { code: '+45',   iso: 'DK', country: 'Denmark' },
  { code: '+253',  iso: 'DJ', country: 'Djibouti' },
  { code: '+1767', iso: 'DM', country: 'Dominica' },
  { code: '+1809', iso: 'DO', country: 'Dominican Republic' },
  { code: '+593',  iso: 'EC', country: 'Ecuador' },
  { code: '+20',   iso: 'EG', country: 'Egypt' },
  { code: '+503',  iso: 'SV', country: 'El Salvador' },
  { code: '+240',  iso: 'GQ', country: 'Equatorial Guinea' },
  { code: '+291',  iso: 'ER', country: 'Eritrea' },
  { code: '+372',  iso: 'EE', country: 'Estonia' },
  { code: '+268',  iso: 'SZ', country: 'Eswatini' },
  { code: '+251',  iso: 'ET', country: 'Ethiopia' },
  { code: '+679',  iso: 'FJ', country: 'Fiji' },
  { code: '+358',  iso: 'FI', country: 'Finland' },
  { code: '+33',   iso: 'FR', country: 'France' },
  { code: '+241',  iso: 'GA', country: 'Gabon' },
  { code: '+220',  iso: 'GM', country: 'Gambia' },
  { code: '+995',  iso: 'GE', country: 'Georgia' },
  { code: '+49',   iso: 'DE', country: 'Germany' },
  { code: '+233',  iso: 'GH', country: 'Ghana' },
  { code: '+30',   iso: 'GR', country: 'Greece' },
  { code: '+1473', iso: 'GD', country: 'Grenada' },
  { code: '+502',  iso: 'GT', country: 'Guatemala' },
  { code: '+224',  iso: 'GN', country: 'Guinea' },
  { code: '+245',  iso: 'GW', country: 'Guinea-Bissau' },
  { code: '+592',  iso: 'GY', country: 'Guyana' },
  { code: '+509',  iso: 'HT', country: 'Haiti' },
  { code: '+504',  iso: 'HN', country: 'Honduras' },
  { code: '+852',  iso: 'HK', country: 'Hong Kong' },
  { code: '+36',   iso: 'HU', country: 'Hungary' },
  { code: '+354',  iso: 'IS', country: 'Iceland' },
  { code: '+62',   iso: 'ID', country: 'Indonesia' },
  { code: '+98',   iso: 'IR', country: 'Iran' },
  { code: '+964',  iso: 'IQ', country: 'Iraq' },
  { code: '+353',  iso: 'IE', country: 'Ireland' },
  { code: '+972',  iso: 'IL', country: 'Israel' },
  { code: '+39',   iso: 'IT', country: 'Italy' },
  { code: '+1876', iso: 'JM', country: 'Jamaica' },
  { code: '+81',   iso: 'JP', country: 'Japan' },
  { code: '+962',  iso: 'JO', country: 'Jordan' },
  { code: '+7',    iso: 'KZ', country: 'Kazakhstan' },
  { code: '+254',  iso: 'KE', country: 'Kenya' },
  { code: '+686',  iso: 'KI', country: 'Kiribati' },
  { code: '+850',  iso: 'KP', country: 'Korea (North)' },
  { code: '+82',   iso: 'KR', country: 'Korea (South)' },
  { code: '+383',  iso: 'XK', country: 'Kosovo' },
  { code: '+965',  iso: 'KW', country: 'Kuwait' },
  { code: '+996',  iso: 'KG', country: 'Kyrgyzstan' },
  { code: '+856',  iso: 'LA', country: 'Laos' },
  { code: '+371',  iso: 'LV', country: 'Latvia' },
  { code: '+961',  iso: 'LB', country: 'Lebanon' },
  { code: '+266',  iso: 'LS', country: 'Lesotho' },
  { code: '+231',  iso: 'LR', country: 'Liberia' },
  { code: '+218',  iso: 'LY', country: 'Libya' },
  { code: '+423',  iso: 'LI', country: 'Liechtenstein' },
  { code: '+370',  iso: 'LT', country: 'Lithuania' },
  { code: '+352',  iso: 'LU', country: 'Luxembourg' },
  { code: '+853',  iso: 'MO', country: 'Macau' },
  { code: '+261',  iso: 'MG', country: 'Madagascar' },
  { code: '+265',  iso: 'MW', country: 'Malawi' },
  { code: '+60',   iso: 'MY', country: 'Malaysia' },
  { code: '+960',  iso: 'MV', country: 'Maldives' },
  { code: '+223',  iso: 'ML', country: 'Mali' },
  { code: '+356',  iso: 'MT', country: 'Malta' },
  { code: '+692',  iso: 'MH', country: 'Marshall Islands' },
  { code: '+222',  iso: 'MR', country: 'Mauritania' },
  { code: '+230',  iso: 'MU', country: 'Mauritius' },
  { code: '+52',   iso: 'MX', country: 'Mexico' },
  { code: '+691',  iso: 'FM', country: 'Micronesia' },
  { code: '+373',  iso: 'MD', country: 'Moldova' },
  { code: '+377',  iso: 'MC', country: 'Monaco' },
  { code: '+976',  iso: 'MN', country: 'Mongolia' },
  { code: '+382',  iso: 'ME', country: 'Montenegro' },
  { code: '+212',  iso: 'MA', country: 'Morocco' },
  { code: '+258',  iso: 'MZ', country: 'Mozambique' },
  { code: '+95',   iso: 'MM', country: 'Myanmar' },
  { code: '+264',  iso: 'NA', country: 'Namibia' },
  { code: '+674',  iso: 'NR', country: 'Nauru' },
  { code: '+977',  iso: 'NP', country: 'Nepal' },
  { code: '+31',   iso: 'NL', country: 'Netherlands' },
  { code: '+64',   iso: 'NZ', country: 'New Zealand' },
  { code: '+505',  iso: 'NI', country: 'Nicaragua' },
  { code: '+227',  iso: 'NE', country: 'Niger' },
  { code: '+234',  iso: 'NG', country: 'Nigeria' },
  { code: '+389',  iso: 'MK', country: 'North Macedonia' },
  { code: '+47',   iso: 'NO', country: 'Norway' },
  { code: '+968',  iso: 'OM', country: 'Oman' },
  { code: '+92',   iso: 'PK', country: 'Pakistan' },
  { code: '+680',  iso: 'PW', country: 'Palau' },
  { code: '+970',  iso: 'PS', country: 'Palestine' },
  { code: '+507',  iso: 'PA', country: 'Panama' },
  { code: '+675',  iso: 'PG', country: 'Papua New Guinea' },
  { code: '+595',  iso: 'PY', country: 'Paraguay' },
  { code: '+51',   iso: 'PE', country: 'Peru' },
  { code: '+63',   iso: 'PH', country: 'Philippines' },
  { code: '+48',   iso: 'PL', country: 'Poland' },
  { code: '+351',  iso: 'PT', country: 'Portugal' },
  { code: '+974',  iso: 'QA', country: 'Qatar' },
  { code: '+40',   iso: 'RO', country: 'Romania' },
  { code: '+7',    iso: 'RU', country: 'Russia' },
  { code: '+250',  iso: 'RW', country: 'Rwanda' },
  { code: '+1869', iso: 'KN', country: 'Saint Kitts and Nevis' },
  { code: '+1758', iso: 'LC', country: 'Saint Lucia' },
  { code: '+1784', iso: 'VC', country: 'Saint Vincent and the Grenadines' },
  { code: '+685',  iso: 'WS', country: 'Samoa' },
  { code: '+378',  iso: 'SM', country: 'San Marino' },
  { code: '+239',  iso: 'ST', country: 'Sao Tome and Principe' },
  { code: '+966',  iso: 'SA', country: 'Saudi Arabia' },
  { code: '+221',  iso: 'SN', country: 'Senegal' },
  { code: '+381',  iso: 'RS', country: 'Serbia' },
  { code: '+248',  iso: 'SC', country: 'Seychelles' },
  { code: '+232',  iso: 'SL', country: 'Sierra Leone' },
  { code: '+65',   iso: 'SG', country: 'Singapore' },
  { code: '+421',  iso: 'SK', country: 'Slovakia' },
  { code: '+386',  iso: 'SI', country: 'Slovenia' },
  { code: '+677',  iso: 'SB', country: 'Solomon Islands' },
  { code: '+252',  iso: 'SO', country: 'Somalia' },
  { code: '+27',   iso: 'ZA', country: 'South Africa' },
  { code: '+211',  iso: 'SS', country: 'South Sudan' },
  { code: '+34',   iso: 'ES', country: 'Spain' },
  { code: '+94',   iso: 'LK', country: 'Sri Lanka' },
  { code: '+249',  iso: 'SD', country: 'Sudan' },
  { code: '+597',  iso: 'SR', country: 'Suriname' },
  { code: '+46',   iso: 'SE', country: 'Sweden' },
  { code: '+41',   iso: 'CH', country: 'Switzerland' },
  { code: '+963',  iso: 'SY', country: 'Syria' },
  { code: '+886',  iso: 'TW', country: 'Taiwan' },
  { code: '+992',  iso: 'TJ', country: 'Tajikistan' },
  { code: '+255',  iso: 'TZ', country: 'Tanzania' },
  { code: '+66',   iso: 'TH', country: 'Thailand' },
  { code: '+670',  iso: 'TL', country: 'Timor-Leste' },
  { code: '+228',  iso: 'TG', country: 'Togo' },
  { code: '+676',  iso: 'TO', country: 'Tonga' },
  { code: '+1868', iso: 'TT', country: 'Trinidad and Tobago' },
  { code: '+216',  iso: 'TN', country: 'Tunisia' },
  { code: '+90',   iso: 'TR', country: 'Turkey' },
  { code: '+993',  iso: 'TM', country: 'Turkmenistan' },
  { code: '+688',  iso: 'TV', country: 'Tuvalu' },
  { code: '+256',  iso: 'UG', country: 'Uganda' },
  { code: '+380',  iso: 'UA', country: 'Ukraine' },
  { code: '+971',  iso: 'AE', country: 'UAE' },
  { code: '+44',   iso: 'GB', country: 'United Kingdom' },
  { code: '+1',    iso: 'US', country: 'United States' },
  { code: '+598',  iso: 'UY', country: 'Uruguay' },
  { code: '+998',  iso: 'UZ', country: 'Uzbekistan' },
  { code: '+678',  iso: 'VU', country: 'Vanuatu' },
  { code: '+379',  iso: 'VA', country: 'Vatican City' },
  { code: '+58',   iso: 'VE', country: 'Venezuela' },
  { code: '+84',   iso: 'VN', country: 'Vietnam' },
  { code: '+967',  iso: 'YE', country: 'Yemen' },
  { code: '+260',  iso: 'ZM', country: 'Zambia' },
  { code: '+263',  iso: 'ZW', country: 'Zimbabwe' },
];

/**
 * Get ISO country code from a dial code like '+91'
 * Returns '' if not found
 */
export function getIsoFromDialCode(dialCode) {
  if (!dialCode) return '';
  const match = COUNTRY_CODES.find(c => c.code === dialCode);
  return match ? match.iso : '';
}
